var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Widget } from '@web/components/layout/Widget';
import Members from '@web/components/Settings/Members/Members';
import { Trans } from 'react-i18next';
export var FirstStep = function () {
    return (_jsxs(_Fragment, { children: [_jsx(Widget, __assign({ className: "mb-2.5 rounded-md", cardClassName: "bg-blue-50" }, { children: _jsx("div", __assign({ className: "flex flex-col sm:flex-row justify-between gap-3" }, { children: _jsxs("div", __assign({ className: "inline-flex justify-between gap-3" }, { children: [_jsx("div", __assign({ className: "w-5 h-5 relative" }, { children: _jsx(InformationCircleIcon, { className: "w-full h-full text-blue-400" }) })), _jsx("div", __assign({ className: " items-center gap-2.5 flex" }, { children: _jsx("div", __assign({ className: "text-blue-800 text-sm font-normal leading-tight" }, { children: _jsx(Trans, { i18nKey: "onboarding.page.stepOneNote", components: {
                                            space: _jsx("br", {}),
                                            bold: _jsx("span", { className: "font-bold" })
                                        } }) })) }))] })) })) })), _jsx("div", __assign({ className: "py-5" }, { children: _jsx(Members, {}) }))] }));
};
